import React from "react";
import "./about-us.scss";

const AboutUs = () => (
  <div className="about-us">
    <div className="about-us__title">About Me</div>
    <div className="about-us__text">
      My name is Jonathan Daniel. I was born in 1965 on a farm in Zimbabwe, and
      I am the oldest of nine children. Because my parents were so poor, I spent
      my childhood with no clothes, money, or toys.
    </div>
    <div className="about-us__text">
      Although we were materially poor, my family was rich in values and
      tradition. Poverty forces you to be adventurous, creative, and a dreamer.
      Sometimes people make poor choices in their poor condition that result in
      bad consequences, but others make positive choices that form positive
      talents to last a lifetime.
    </div>
    <div className="about-us__text">
      I remember as a young boy I asked my dad for a toy. He handed me an ax and
      said, “With this tool, you can create any toy you can imagine.” As strange
      as it sounds, he was right.
    </div>
    <div className="about-us__text">
      I remember carrying that ax over my shoulder, looking at branches and
      envisioning interesting pictures of toys to be carved. I began to expand
      my imagination of what a toy should look like, and it enriched my
      perceptions in creating ideas. I became adventurous and started to utilize
      the environment around me for all my basic needs.
    </div>
    <div className="about-us__text">
      There was a grocery store three miles away which we visited daily to buy
      bread and milk. When I was old enough to make this trip, I began to see
      cars and trucks that I had never imagined. I was fascinated by the beauty
      and strangeness of them all. With each new vehicle I saw, I would run all
      three miles home and share what I had seen.
    </div>
    <div className="about-us__text">
      Because I was unable to describe the vehicles, I began carrying a piece of
      scrap wire around my neck to make the outlined shape of the vehicle and
      take it home to share. I began to add to the wire vehicle to the point
      where I had created a completed vehicle out of trash. I was able to
      “push-drive” them everywhere I went.
    </div>
    <div className="about-us__text">
      I quickly acquired the nickname “Wire Boy” from those on the farm.
    </div>
    <div className="about-us__text">
      My wire art blossomed when I came to America and allowed me to help fund
      my schooling. Although I had plans to return to Zimbabwe afterwards, I
      decided to use my passion of working with the youth to become a Youth
      Minister in North Carolina. Although I love working with the youth in
      America, I have never lost my passion for the work still to be done in
      Zimbabwe.
    </div>
  </div>
);

export default AboutUs;
